import { __assign, __read, __rest } from "tslib";
/**
 * @see https://github.com/NervJS/taro/blob/next/packages/taro-components/src/components/text/text.tsx
 */
import React, { useRef, useState } from "react";
import classNames from "classnames";
import { mergeRefs } from "../../../_util/merge-refs";
import { noop } from "../../../_util/noop";
import { View } from "../view";
import { createEvent } from "../_util/create-event";
export var Image = React.forwardRef(function Image(_a, ref) {
    var _b;
    var src = _a.src, _c = _a.mode, mode = _c === void 0 ? "scaleToFill" : _c, _d = _a.onLoad, onLoad = _d === void 0 ? noop : _d, _e = _a.onError, onError = _e === void 0 ? noop : _e, className = _a.className, props = __rest(_a, ["src", "mode", "onLoad", "onError", "className"]);
    var imgRef = useRef(null);
    var _f = __read(useState("width"), 2), aspectFillMode = _f[0], setAspectFillMode = _f[1];
    function handleLoad(event) {
        var _a = imgRef.current, width = _a.width, height = _a.height, naturalWidth = _a.naturalWidth, naturalHeight = _a.naturalHeight;
        onLoad(createEvent(event, {
            width: width,
            height: height,
        }));
        setAspectFillMode(naturalWidth > naturalHeight ? "width" : "height");
    }
    return (React.createElement(View, __assign({ className: classNames(className, "tea-core-image") }, props),
        React.createElement("img", { alt: "", ref: mergeRefs(ref, imgRef), src: src, className: classNames("tea-core-image__mode-" + mode.toLowerCase().replace(/\s/g, ""), (_b = {},
                _b["tea-core-image__mode-aspectfill--" + aspectFillMode] = mode === "aspectFill",
                _b)), onLoad: handleLoad, onError: onError })));
});
//# sourceMappingURL=Image.js.map